// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import Close from "@store/Library/Components/Toolkit/Icons/Close";
import { buttonResetStyles } from "@store/Themes/common/mixins/button";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

const tag: Styleguide["tag"] = {
    defaultProps: {
        mergeCss: true,
        color: "info.alt",
        typographyProps: {
            color: "primary",
            // size: TYPOGRAPHY.size.smaller,
            css: css`
                /* white-space: nowrap; */
                overflow: hidden;
                text-overflow: ellipsis;
            `,
        },
        iconProps: {
            src: Close,
            size: 20,
            color: "primary.main",
        },
        css: css`
            display: flex;
            align-items: center;
            padding: 0.3em 0.5em 0.3em 0.75em;
            border-radius: 1em;
            margin: 0 ${pxToRem(10)} ${pxToRem(13)} 0;

            > button {
                min-width: 0;
                min-height: 0;
                ${transitionHoverStyles()};
                margin-left: ${pxToRem(4)};
                &:hover {
                    background-color: transparent;
                    svg {
                        color: ${getColor("secondary.main")};
                    }
                }
            }
        `,
    },
};

export default tag;
